import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LogoService } from '@app/core/services/logo/logo.service';
import { DotLoaderComponent } from '@app/shared/components/dot-loader/dot-loader.component';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { FullscreenLoaderService, FullscreenLoaderState } from './fullscreen-loader.service';

@Component({
  selector: 'sliqpay-fullscreen-loader',
  templateUrl: './fullscreen-loader.component.html',
  styleUrls: ['./fullscreen-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DotLoaderComponent, AsyncPipe]
})
export class FullscreenLoaderComponent implements OnInit {
  themePath = environment.client;
  logoPath = '';

  fullscreenLoaderState$!: Observable<FullscreenLoaderState>;

  constructor(
    private service: FullscreenLoaderService,
    private logoService: LogoService
  ) {}

  ngOnInit(): void {
    this.fullscreenLoaderState$ = this.service.fullscreenUiState$();
    this.logoPath = this.logoService.getLogoFilePath('payon-light');
  }
}
